module.exports = __webpack_public_path__ + "RMR LSA Enrollment Guide.pdf";